<strong>Average Bitrate:</strong> {{bitrateStats.currentBitrate}} kbits/sec (max: {{bitrateStats.maxBitrate}} kbits/sec)
